import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  Select,
  TextField,
  Typography,
  MenuItem,
} from "@mui/material";
import { useEffect, useState } from "react";
import { CommonService } from "../services/CommonService";
import { useLocalStorage } from "../auth/useLocalStorage";
import {
  IDetails,
  IExpensesConcept,
  IExpensesSupplier,
  IPurchaseOrder,
} from "../common/interfaces";
import Swal from "sweetalert2";
import "@sweetalert2/theme-dark/dark.css"
import withReactContent from "sweetalert2-react-content";
import {v4} from "uuid"

interface ExpensesProps {
  handleCancel: () => void;
}

export const Expenses = (props: ExpensesProps) => {
  const { handleCancel } = props;
  const [amount, setAmount] = useState("");
  const [code, setCode] = useState("");
  const [user, setUser] = useLocalStorage("user", null);
  const [maxAmount, setMaxAmount] = useState(0);
  const [suppliers, setSuppliers] = useState<IExpensesSupplier[]>();
  const [poList, setPOList] = useState<any[]>();
  const [pO, setPO] = useState<any>();
  const [selectedPO, setSelectedPO] = useState<IPurchaseOrder>();
  const [selectedProduct, setSelectedProduct] = useState<any>();
  const [step, setStep] = useState("first");
  const [selectedSupplier, setSelectedSupplier] = useState<string[]>([]);
  const [selectedConcept, setSelectedConcept] = useState<string[]>([]);
  const [supplier, setSupplier] = useState<IExpensesSupplier>();
  const [filter, setFilter] = useState("");
  const [allSuppliers, setAllSuppliers] = useState<IExpensesSupplier[]>();
  const [allConcepts, setAllConcepts] = useState<IExpensesConcept[]>();
  const [notes, setNotes] = useState("");
  const [serie, setSerie] = useState("");
  const [folio, setFolio] = useState("");
  const [uuid, setUUID] = useState("");
  const [iva, setIva] = useState(0);
  const [search, setSearch] = useState("");
  const [listItems, setListItems] = useState<IExpensesConcept[]>();
  const [total, setTotal] = useState(0);

  const [isConceptDisabled, setIsConceptDisabled] = useState(false);
  const [currency, setCurrency] = useState("MXN");

  const style = {
    width: "100%",
    maxWidth: 360,
    border: "1px solid #fff",
    // bgcolor: 'background.paper',
  };
  const MySwal = withReactContent(Swal);
  function ccyFormat(num: number) {
    return `${num.toFixed(2)}`;
  }
  const handleStep = () => {

    if (selectedSupplier.length === 0) {
      MySwal.fire({
        icon: "error",
        toast: true,
        position: "top-end",
        title: "Debe seleccionar un proveedor para continuar",
        showConfirmButton: false,
        timer: 1500,
      });
      return;
    }
    changeStep("second");
  };
  const changeStep = (step: string) => setStep(step);
  const execute = async () => {
    const {success, object: {amount: availableCash}} = await CommonService.getAmountCash(user?.cbox.id, currency);
    if(!success){
      CommonService.displayAlert("No tienes suficientes fondos en caja para continuar", "error")
      return
    }
    if(Number(amount) > availableCash){
      CommonService.displayAlert("No tienes suficientes fondos en caja para continuar", "error")
      return;
    }
    CommonService.getAmountCash(user.cbox.id ?? 0, currency).then((res) => {
      if(res.success){
        setMaxAmount(parseFloat(res.object.amount));
      }
    })
    if (total > 0 && selectedConcept[0]) {
      const concepto = listItems?.find(e => e.id === Number(selectedConcept[0]));
      const proveedor = suppliers?.find((item) => item.id === Number(selectedSupplier[0]));

      MySwal.fire({
        title: "Confirmar Gasto",
        icon: "question",
        html: `
          <div style="text-align: left; padding: 20px;">
            <div style="margin-bottom: 15px;">
              <strong>Proveedor:</strong><br/>
              <span style="color: #1976d2; font-size: 1.1em;">${proveedor?.name}</span>
            </div>
            <div style="margin-bottom: 15px;">
              <strong>Concepto:</strong><br/>
              <span style="color: #1976d2; font-size: 1.1em;">${concepto?.name}</span>
            </div>
            <div style="margin-bottom: 15px;">
              <strong>Subtotal:</strong><br/>
              <span style="font-size: 1em;">$ ${Number(amount).toFixed(2)} ${currency}</span>
            </div>
            <div style="margin-bottom: 15px;">
              <strong>IVA:</strong><br/>
              <span style="font-size: 1em;">${(iva * 100).toFixed(0)}%</span>
            </div>
            ${notes ? `<div style="margin-bottom: 15px;">
              <strong>Observaciones:</strong><br/>
              <span style="font-size: 0.95em;">${notes}</span>
            </div>` : ''}
            <div style="border-top: 2px solid #1976d2; padding-top: 15px; margin-top: 15px;">
              <strong style="font-size: 1.2em;">Total: $ ${total.toFixed(2)} ${currency}</strong>
            </div>
          </div>
        `,
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#4caf50",
        cancelButtonColor: "#f44336",
      }).then((result) => {
        if(result.isConfirmed){
          CommonService.createExpenses({
            concept_id: selectedConcept[0],
            supplier_id: selectedSupplier[0],
            user_id: user?.id,
            notes,
            serie,
            folio,
            iva,
            amount: Number(amount),
            total,
            cashBoxId: user?.cbox.id,
            currency
          }).then(async (res) => {
            if (res.success) {
              MySwal.fire({
                icon: "success",
                toast: true,
                position: "top-end",
                title: "Gasto Creado con éxito",
                showConfirmButton: false,
                timer: 1500,
              });
              handleCancel()
              clean()

              const idAuth = v4();
              CommonService.requestAuthorize({
                message: `Se solicita Autorizar un Gasto $ ${total.toFixed(2)} (${currency})`, // => $req->message,
                action: {
                  type: "authorize-bill",
                  item: { bill: res.object.id },
                  id: idAuth,
                  content: `Se solicita Autorizar un Gasto. <br/> <b>Total:</b> $ ${total.toFixed(2)} (${currency})<br/> <b>Proveedor:</b> <br /> ${proveedor?.name} <br /> <b>Concepto:</b> <br /> ${concepto?.name} <br /><b>Observaciones:</b> <br /> ${notes}`,
                }, // => $req->action,
                status: "pending", // => 'pending', // Set the initial status
                from: user.id, // => $req->from,
                to: 1, // => $req->to,
              }).then(() => {
                CommonService.toast(
                  "Se envío solicitud de Autorización, para validar Gasto",
                  "success"
                );
                handleCancel();
              });

              // CommonService.generatePrintCommand(res.object.id, 'bill').then(e => console.log(e))

              // CommonService.printTicketPOR(res.object.id).then((e) =>
              //   console.log(e)
              // );
              return;
            }
            MySwal.fire({
              icon: "error",
              toast: true,
              position: "top-end",
              title: "Error al crear la recepción",
              showConfirmButton: false,
              timer: 1500,
            });
          });
        }
      });
    }
  };
  const clean = () => {
    setSelectedSupplier([]);
    setSelectedConcept([]);
    cleanForm();
  };
  const cleanForm = () => {
    setAmount("");
    setSearch("");
    setNotes("");
    setSerie("");
    setFolio("");
    setIva(0);
  };
  const updateObject = () => {
    if (!selectedPO) return;
    let total = 0;
    const newPo = selectedPO;
    newPo.details.map((element) => {
      element.total = (
        Number(element.price) * (1 + iva) * Number(element.quantity) -
        Number(element.discount)
      ).toFixed(2);
      element.tax = (Number(element.total) * iva).toFixed(2);
      return element;
    });
    total = selectedPO.details.reduce<number>(
      (acc, element) =>
        acc +
        (Number(element.price) * Number(element.quantity) -
          Number(element.discount)),
      0
    );

    console.log({ total });
    setSelectedPO({
      ...newPo,
      total: total.toFixed(2),
      grand_total: (total * (1 + iva)).toFixed(2),
      tax: (total * iva).toFixed(2),
    });
  };
  useEffect(() => {
    CommonService.getExpensesSuppliers().then((res) => {
      setSuppliers(res);
      setAllSuppliers(res);

      if(res && res.length > 0){
        setSelectedSupplier([String(res[0].id)]);
      }
      
    });
    CommonService.getExpensesConcepts().then((res) => {
      setListItems(res);
      setAllConcepts(res);
    });
  }, []);

  useEffect(() => {
    if (step === "second") {
      CommonService.getPO({
        custom: `supplier_id=${selectedSupplier},warehouse_id=${user?.warehouse_id}`,
      }).then((res) => {
        console.log({ res });
        setPOList(
          res.filter((item: IPurchaseOrder) => item.status === "Aprobado")
        );
      });
    }
  }, [step]);
  useEffect(() => {
    if (selectedSupplier[0] !== "") {
      setSupplier(
        suppliers?.find((item) => item.id === Number(selectedSupplier))
      );
    }
  }, [selectedSupplier]);
  useEffect(() => {
    const results = allSuppliers?.filter((e) =>
      e.name.toLowerCase().includes(filter.trim().toLowerCase())
    );
    setSuppliers(results);

    if(results && results.length > 0){
      setSelectedSupplier([String(results[0].id)]);
    }
  }, [filter]);

  useEffect(() => {
    const results = allConcepts?.filter((e) =>
      e.name.toLowerCase().includes(search.trim().toLowerCase())
    );
    setListItems(results);

    // Auto-seleccionar si hay resultados (igual que proveedor)
    if(results && results.length > 0){
      setSelectedConcept([String(results[0].id)]);
    }
  }, [search]);

  useEffect(() => {
    updateObject();
  }, [iva]);

  useEffect(() => {
    console.log("Calculate Total");
    const numAmount = Number(amount);
    if (numAmount > 0) {
      setTotal(numAmount * (1 + iva));
      return;
    }
    setTotal(0);
  }, [amount, iva]);


  useEffect(() => {
    if (selectedSupplier[0] !== "") {
      const selected = suppliers?.find((item) => item.id === Number(selectedSupplier[0]));
      setSupplier(selected);

      // Check if the selected supplier has a bills_concepts_id
      if (selected?.bills_concepts_id) {
        setSelectedConcept([String(selected.bills_concepts_id)]);
        setIsConceptDisabled(true);
      } else {
        setSelectedConcept([]); // Allow user to select manually
        setIsConceptDisabled(false);
      }
    }
  }, [selectedSupplier, suppliers]);

  function deleteItem(item: IDetails): void {
    const changePO = selectedPO;
    const index: number = Number(
      changePO?.details.findIndex((e) => e.id === item.id)
    );
    console.log({ index, item }, changePO?.details);
    if (index !== -1 && changePO) {
      const arr = changePO?.details;
      arr?.splice(index, 1);
      changePO.details = arr;
      setSelectedPO({ ...changePO });
    }
  }

  return (
    <>
      {step === "first" && (
        <div style={{ textAlign: "center", maxHeight: "calc(100vh - 200px)", overflowY: "auto", paddingRight: "8px" }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h5" style={{ marginBottom: "20px", fontWeight: "bold" }}>
                Seleccione un Proveedor
              </Typography>
              <Grid item xs={12}>
                <TextField
                  id="outlined-basic"
                  style={{ width: "100%" }}
                  label="Busque su proveedor"
                  variant="outlined"
                  value={filter}
                  onChange={(e) => setFilter(e.target.value)}
                  size="medium"
                />
              </Grid>
              <FormControl fullWidth style={{ marginTop: 24 }}>
                <InputLabel id="supplier-select-label">Proveedores</InputLabel>
                <Select
                  labelId="supplier-select-label"
                  id="supplier-select"
                  value={selectedSupplier[0] || ""}
                  label="Proveedores"
                  onChange={(e) => {
                    const value = e.target.value as string;
                    if (value !== "") {
                      setSelectedSupplier([value]);
                    }
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 400,
                        width: 350,
                      },
                    },
                  }}
                >
                  {suppliers &&
                    suppliers.map((item: IExpensesSupplier, index: number) => (
                      <MenuItem value={item.id} key={index}>
                        <strong>{item.name}</strong>
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <div style={{ marginTop: "24px", display: "flex", gap: "12px", justifyContent: "center", flexWrap: "wrap" }}>
            <Button
              variant="outlined"
              size="large"
              onClick={() => handleCancel()}
              sx={{ minWidth: "140px" }}
            >
              Cancelar
            </Button>

            <Button
              variant="contained"
              size="large"
              onClick={() => handleStep()}
              sx={{ minWidth: "140px" }}
            >
              Siguiente
            </Button>
          </div>
        </div>
      )}
      {step === "second" && (
        <div style={{ textAlign: "center", maxHeight: "calc(100vh - 200px)", overflowY: "auto", paddingRight: "8px" }}>
          <Typography variant="h5" style={{ textAlign: "left", marginBottom: "16px", fontWeight: "bold" }}>
            Proveedor: <span style={{ color: "#1976d2" }}>{supplier?.name}</span>
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                id="serieField"
                fullWidth
                label="Serie"
                variant="outlined"
                value={serie}
                onChange={(e) => setSerie(e.target.value)}
                size="medium"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                id="folioField"
                fullWidth
                label="Folio"
                variant="outlined"
                value={folio}
                onChange={(e) => setFolio(e.target.value)}
                size="medium"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="searchField"
                fullWidth
                label="Busque su Concepto"
                variant="outlined"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                disabled={isConceptDisabled}
                size="medium"
                style={{ marginBottom: "16px" }}
              />
              <FormControl fullWidth>
                <InputLabel id="concept-select-label">Conceptos</InputLabel>
                <Select
                  labelId="concept-select-label"
                  id="concept-select"
                  value={selectedConcept[0] || ""}
                  label="Conceptos"
                  onChange={(e) => {
                    const value = e.target.value as string;
                    if (value !== "") {
                      setSelectedConcept([value]);
                    }
                  }}
                  disabled={isConceptDisabled}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 400,
                        width: 350,
                      },
                    },
                  }}
                >
                  {listItems &&
                    listItems.map((item, index: number) => (
                      <MenuItem value={item.id} key={index}>
                        <strong>{item.name}</strong>
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth>
                <InputLabel id="currency-label">Moneda</InputLabel>
                <Select
                  labelId="currency-label"
                  id="currency-select"
                  value={currency}
                  label="Moneda"
                  onChange={(e) => setCurrency(e.target.value)}
                >
                  <MenuItem value="MXN">MXN - Peso Mexicano</MenuItem>
                  <MenuItem value="USD">USD - Dólar Estadounidense</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                id="subtotal"
                fullWidth
                label="Subtotal"
                variant="outlined"
                type="number"
                inputProps={{ step: "0.01", min: "0" }}
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                size="medium"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth>
                <InputLabel id="iva-label">IVA</InputLabel>
                <Select
                  labelId="iva-label"
                  id="iva-select"
                  value={iva}
                  label="IVA"
                  onChange={(e) => setIva(Number(e.target.value))}
                >
                  <MenuItem value={0}>0%</MenuItem>
                  <MenuItem value={0.08}>8%</MenuItem>
                  <MenuItem value={0.16}>16%</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="standard-multiline-static"
                label="Observaciones"
                multiline
                rows={3}
                fullWidth
                variant="outlined"
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                size="medium"
              />
            </Grid>
            <Grid item xs={12} style={{ textAlign: "right", marginTop: "16px" }}>
              <div style={{
                backgroundColor: "#1976d2",
                padding: "16px",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
              }}>
                <Typography variant="h4" style={{ fontWeight: "bold", color: "white" }}>
                  TOTAL: ${ccyFormat(total)} {currency}
                </Typography>
              </div>
            </Grid>
          </Grid>
          <div style={{ marginTop: "24px", display: "flex", gap: "12px", justifyContent: "center", flexWrap: "wrap" }}>
            <Button
              variant="outlined"
              size="large"
              onClick={() => {
                clean();
                handleCancel();
              }}
              sx={{ minWidth: "140px" }}
            >
              Cancelar
            </Button>
            <Button
              variant="outlined"
              size="large"
              onClick={() => {
                cleanForm();
                setStep("first");
              }}
              sx={{ minWidth: "140px" }}
            >
              Atrás
            </Button>
            <Button
              variant="contained"
              size="large"
              onClick={() => execute()}
              sx={{ minWidth: "160px" }}
              color="success"
            >
              Confirmar Gasto
            </Button>
          </div>
        </div>
      )}
    </>
  );
};
